export default "__VITE_ASSET__CmQ7qMaO__"